import {FormSubmission, RsvpStatus} from '@wix/ambassador-events-v2-rsvp/types'
import {INPUT_NAMES, getRsvpFormInputValues, isWaitlistEnabled} from '@wix/wix-events-commons-statics'
import {FormStep} from '../constants'
import {RegFormData} from '../types/registration'
import {State} from '../types/state'
import {getEvent} from './event'

export const shouldNavigateToForm = (state: State) => {
  const eventControls = state ? getEvent(state)?.form?.controls : undefined
  const rsvp = state?.memberRsvp?.rsvp
  const rsvpControls = rsvp ? getRsvpFormInputValues(rsvp) : undefined

  if (eventControls && rsvpControls) {
    const filteredEventControls = eventControls
      .filter(({name}) => name !== INPUT_NAMES.NAME && name !== INPUT_NAMES.EMAIL)
      .map(({name}) => name)
      .sort()
    const filteredRsvpControls = rsvpControls
      .filter(
        ({inputName}) =>
          inputName !== INPUT_NAMES.EMAIL &&
          inputName !== INPUT_NAMES.FIRST_NAME &&
          inputName !== INPUT_NAMES.LAST_NAME &&
          inputName !== INPUT_NAMES.GUEST_NAMES,
      )
      .map(({inputName}) => inputName)
      .sort()
    const eventControlsContainsAllRsvpControls = filteredEventControls.every(val => filteredRsvpControls.includes(val))

    return filteredEventControls.length < filteredRsvpControls.length || !eventControlsContainsAllRsvpControls
  } else {
    return false
  }
}

export const isStepVisible = ({step, hasPolicies}: IsStepVisibleArgs) => {
  switch (step) {
    case FormStep.Policies:
      return hasPolicies
    default:
      return true
  }
}

export const isStepCompleted = ({step, rsvpDetails, formSubmission, agreedWithPolicies}: IsStepCompletedArgs) => {
  switch (step) {
    case FormStep.BuyerDetails:
      return Boolean(rsvpDetails) || Boolean(formSubmission)
    case FormStep.Policies:
      return agreedWithPolicies
    default:
      return false
  }
}

export const getCurrentStep = (state: State) => state.rsvp.currentStep

export const getRsvpDetails = (state: State) => state.rsvp.rsvpDetails

export const getResponse = (state: State) => state.rsvp.response

export const getFormSubmission = (state: State) => state.rsvp.formSubmission

export const resolveGuestDetails = (event: ExtendedEvent, submissions: Record<string, any>) => {
  const status = resolveRsvpStatus(event, submissions.rsvp_status)

  return {
    firstName: submissions.first_name,
    lastName: submissions.last_name,
    email: submissions.email,
    status,
  }
}

export const resolveRsvpStatus = (event: ExtendedEvent, response?: RsvpStatus) => {
  const waitlistEnabled = isWaitlistEnabled(event)

  if (typeof response === 'string' && response.includes('GOING')) {
    // @ts-expect-error this is temporary, will remove as soon as value is changed on form side
    return response === 'GOING' ? RsvpStatus.YES : RsvpStatus.NO
  }

  if (response) {
    return response
  }

  if (waitlistEnabled) {
    return RsvpStatus.WAITLIST
  }

  return RsvpStatus.YES
}

interface IsStepVisibleArgs {
  step: FormStep
  hasPolicies: boolean
}

interface IsStepCompletedArgs {
  step: FormStep
  rsvpDetails: RegFormData
  formSubmission?: FormSubmission
  agreedWithPolicies: boolean
}
